import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import MessagesPageWrapper from "./MessagesPageWrapper";

export function MessagesRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.Student, UserRole.School, UserRole.ServiceProvider]}
          component={MessagesPageWrapper}
        />
        <AuthRoute
          exact
          path={`${path}/:userRole/:recipientId`}
          roles={[UserRole.Student, UserRole.School, UserRole.ServiceProvider]}
          component={MessagesPageWrapper}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
